export default __webpack_public_path__ + "e487e34af8f0881f4a3c6cfc7effb499.svg";